module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.75de32d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/AmwayIcons.ttf?5v2gxx
// module id = RfyE
// module chunks = 0